import { CircleButton, DialogButton, NativeInput, ProductGroup, Switch } from "@tosize/ui";
import { type ChangeEventHandler, useState } from "react";
import { useIntl } from "react-intl";
import { useConfig } from "../../../context/ConfigContext";
import { usePostDataContext } from "../../../context/PostDataContext";
import { ExplanationButton } from "../../ui/ExplanationButton";
// import Input from "../../ui/Input";

export function LabelField() {
	const intl = useIntl();
	const { productGroup } = useConfig();
	const { workpiece, setWorkpiece } = usePostDataContext();
	const [showInput, showInputChange] = useState(!!workpiece.label);
	const limit = 30;

	const onLabelInputChange: ChangeEventHandler<HTMLInputElement> = (e) => {
		setWorkpiece((prev) => ({
			...prev,
			label: e.target.value.slice(0, limit),
		}));
	};

	if (productGroup === ProductGroup.Plastic_Sheet) {
		return null;
	}

	return (
		<div>
			<Switch
				id="label-switch"
				checked={showInput}
				onCheckedChange={(checked) => {
					showInputChange(checked);

					setWorkpiece((prev) => ({
						...prev,
						label: checked ? workpiece.label : undefined,
					}));
				}}
				className="justify-between"
				labelPosition="left"
				label={
					<ExplanationButton title={intl.formatMessage({ defaultMessage: "Eigen kenmerk" })}>
						<DialogButton
							title={intl.formatMessage({ defaultMessage: "Eigen kenmerk" })}
							content={intl.formatMessage({
								defaultMessage:
									"Elk item krijgt een sticker met de naam van de houtsoort, dikte en de afmetingen. Er is ook ruimte om zelf tekst toe te voegen. De omschrijving in dit veld printen we op de sticker. Zo maak je eenvoudig je eigen bouwpakket.",
							})}
						>
							<CircleButton component="button" className="text-sm" />
						</DialogButton>
					</ExplanationButton>
				}
			/>

			{showInput && (
				<div className="relative mt-2">
					<NativeInput
						name="label"
						type="text"
						maxLength={30}
						value={workpiece.label}
						onChange={onLabelInputChange}
					/>
					<span className="pointer-events-none absolute right-0 border border-transparent py-2 pr-3 text-shades-dark text-sm leading-[1.5rem]">
						{workpiece.label?.length}/{limit}
					</span>
				</div>
			)}
		</div>
	);
}
